import { SM4 } from "./index.es126.js";
const _4 = {
  /**
   * 加密数据
   * @param {string|Uint8Array} originalData - 待加密的数据
   * @param {string|Uint8Array} key - 加密密钥
   * @param {Object} [options] - 加密选项
   * @param {('ecb'|'cbc')} [options.mode='ecb'] - 加密模式
   * @param {('pkcs7'|'none')} [options.padding='pkcs7'] - 填充方式
   * @param {('hex'|'array')} [options.output='hex'] - 输出格式
   * @param {string|Uint8Array} [options.iv] - 初始向量
   * @returns {string|Uint8Array} - 加密后的数据
   */
  encrypt: (originalData, key, options = {}) => {
    if (originalData === "" || originalData === null || originalData === void 0) {
      return originalData;
    }
    try {
      const encrypted = SM4(originalData + "", key, 1, options);
      if (options.output === "array") {
        return encrypted;
      } else {
        return encrypted.toString("hex");
      }
    } catch (error) {
      console.error("🐛: ~ encrypt ~ error:", originalData, error);
      return originalData;
    }
  },
  /**
   * 解密数据
   * @param {string|Uint8Array} encryptedData - 待解密的数据
   * @param {string|Uint8Array} key - 解密密钥
   * @param {Object} [options] - 解密选项
   * @param {('ecb'|'cbc')} [options.mode='ecb'] - 解密模式
   * @param {('pkcs7'|'none')} [options.padding='pkcs7'] - 填充方式
   * @param {('utf8'|'array')} [options.output='utf8'] - 输出格式
   * @param {string|Uint8Array} [options.iv] - 初始向量
   * @returns {string|Uint8Array} - 解密后的数据
   */
  decrypt: (encryptedData, key, options = {}) => {
    if (encryptedData === "" || encryptedData === null || encryptedData === void 0) {
      return encryptedData;
    }
    try {
      const decrypted = SM4(encryptedData, key, 0, options);
      if (decrypted === "") {
        throw new Error("Decryption failed");
      }
      if (options.output === "array") {
        return decrypted;
      } else {
        const decryptedStr = decrypted.toString("utf8");
        try {
          return JSON.parse(decryptedStr);
        } catch (parseError) {
          return decryptedStr;
        }
      }
    } catch (error) {
      console.error("🐛: ~ decrypt ~ error:", encryptedData, error);
      return encryptedData;
    }
  }
};
export {
  _4 as default
};
